import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { PauseSvg } from './Pause';

export const PauseIcon = createIcon('pause', PauseSvg);
/**
 * @deprecated используйте PauseIcon
 */
export const withPauseIcon = withIcon('pause', PauseSvg);
